<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const handleInput = (value: boolean) => {
  props.context.node.input(value)
}

const label = computed(
  () => props.context.label || props.context.attrs?.placeholder,
)
</script>

<template>
  <div
    class="formkit-outer formkit-disabled:opacity-50 flex"
    :class="context.help && 'flex-col'"
  >
    <SwitchGroup as="div" class="flex items-center">
      <Switch
        :model-value="context._value"
        :disabled="context.disabled"
        :class="[
          context._value ? 'bg-primary-600' : 'bg-gray-200',
          'relative inline-flex flex-shrink-0 h-6 w-11 md:h-5 md:w-9 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500',
          context.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        ]"
        @update:model-value="handleInput"
      >
        <span
          aria-hidden="true"
          :class="[
            context._value ? 'translate-x-5 md:translate-x-4' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 md:h-4 md:w-4 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
          ]"
        />
      </Switch>
      <SwitchLabel
        v-if="label"
        :class="[
          'ml-2 text-sm font-medium text-gray-700',
          context.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        ]"
      >
        {{ label }}
      </SwitchLabel>
    </SwitchGroup>
    <span
      v-if="context.help"
      class="ml-12 mt-1 text-xs text-gray-500 leading-3"
      >{{ context.help }}</span
    >
  </div>
</template>
